import PhoneUpdatePage from './PhoneUpdatePage';
export default PhoneUpdatePage;